import { render, staticRenderFns } from "./CourseCardsFilters5.vue?vue&type=template&id=50c37a80&"
import script from "./CourseCardsFilters5.vue?vue&type=script&lang=js&"
export * from "./CourseCardsFilters5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports